module.exports = __webpack_public_path__ + "img/banner_icon_1.f6088d13.jpg";